// Rótulos e filtros de Minhas faturas (PO1-3160). Espelha o mapa único do
// backend (meufrete/enums.js): em auditoria = AVA/EVA/VAL e, desde a PO1-3191,
// EAN (9, Em Análise) e ETR (10, Em Tratativa); reprovada = BLO, contestada =
// CON, liberada = LIB, integrada = PAG, paga = PGO (11, PO1-3653), cancelada = CAN. O rótulo vem do
// backend (situacaoCodigo/situacaoRotulo): a transportadora nunca vê "Em
// Análise" nem "Em Tratativa", só "Em auditoria".

export const ROTULOS = [
  { codigo: "em_auditoria", rotulo: "Em auditoria", tone: "info" },
  { codigo: "reprovada", rotulo: "Reprovada", tone: "danger" },
  { codigo: "contestada", rotulo: "Contestada", tone: "warning" },
  { codigo: "liberada", rotulo: "Liberada", tone: "success" },
  { codigo: "integrada", rotulo: "Integrada ao pagamento", tone: "success" },
  { codigo: "paga", rotulo: "Paga", tone: "success" },
  { codigo: "cancelada", rotulo: "Cancelada", tone: "neutral" },
];

export const VENCIMENTO_OPCOES = [
  { value: "", label: "Todas" },
  { value: "vencidas", label: "Vencidas" },
  { value: "a_vencer", label: "A vencer" },
];

export const DATA_CAMPOS = [
  { value: "emissao", label: "Emissão" },
  { value: "vencimento", label: "Vencimento" },
];

// Situações que contam como vencida / a vencer: tudo que não é cancelada,
// liberada, integrada ou paga (mesma regra do backend).
// O backend devolve `situacaoTms` neutro para a transportadora: 'em_auditoria' cobre
// A Validar, Em Validação, Validada, Em Análise e Em Tratativa (PO1-3191); BLO e CON
// seguem com o código. Todas estão em aberto e recebem o alerta de vencimento.
export const SITUACOES_ALERTA_VENCIMENTO = ["em_auditoria", "BLO", "CON"];

export function rotuloDe(codigo) {
  return ROTULOS.find((r) => r.codigo === codigo) || null;
}

export function toneDe(codigo) {
  const r = rotuloDe(codigo);
  return r ? r.tone : "neutral";
}

// Filtros iniciais vindos da URL (link do e-mail da PO1-3161):
// ?situacao=liberada&vencimento=vencidas. Valores desconhecidos são ignorados.
export function filtrosDaUrl(search) {
  const params = new URLSearchParams(search || "");
  const situacao = params.get("situacao") || "";
  const vencimento = params.get("vencimento") || "";
  return {
    situacao: rotuloDe(situacao) ? situacao : "",
    vencimento: VENCIMENTO_OPCOES.some((o) => o.value && o.value === vencimento) ? vencimento : "",
  };
}

export const FILTROS_VAZIOS = {
  situacao: "",
  vencimento: "",
  dataCampo: "emissao",
  dataDe: "",
  dataAte: "",
  numero: "",
};

// Query string do GET /meufrete/faturas a partir dos filtros da tela.
export function montarParams({ filtros, embarcadorId, page, pageSize, sort }) {
  const params = { page, pageSize };
  if (embarcadorId !== null && embarcadorId !== undefined) params.embarcadorId = embarcadorId;
  if (filtros.situacao) params.situacao = filtros.situacao;
  if (filtros.vencimento) params.vencimento = filtros.vencimento;
  if (filtros.dataDe || filtros.dataAte) {
    params.dataCampo = filtros.dataCampo || "emissao";
    if (filtros.dataDe) params.dataDe = filtros.dataDe;
    if (filtros.dataAte) params.dataAte = filtros.dataAte;
  }
  if (filtros.numero) params.numero = String(filtros.numero).trim();
  if (sort && sort.field) {
    params.sortField = sort.field;
    params.sortDir = sort.dir;
  }
  return params;
}
